import React from "react";
import { Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { withDesignFont, designFontFamily } from "services/constants/designTokens";
import PayslipList from "./PayslipList";
import { useSelector } from "react-redux";
import { FilterProvider } from "pages/FilterContext";

export const Payslip = () => {
  const { domain, userDetails, userScreenAccess } = useSelector(
    (state) => state.tokenReducer,
  );
  const myWorkspaceModule = userScreenAccess?.module_details?.find((module) =>
    ["My Workspace", "My Zone"].includes(module.module_name),
  );
  const subModuleId = myWorkspaceModule?.submodules?.find((submodule) =>
    ["Payslip", "Payslips"].includes(submodule.sub_module_name),
  )?.sub_module_id;

  return (
    <ThemeProvider theme={withDesignFont}>
      <FilterProvider
        domain={domain}
        userDetails={userDetails}
        subModuleId={subModuleId}
      >
        <Box sx={{ fontFamily: designFontFamily }}>
          <PayslipList subModuleId={subModuleId} />
        </Box>
      </FilterProvider>
    </ThemeProvider>
  );
};
